const pickUpTypes = {
  PICKUP: 'pickUp',
  OFFICEDELIVERY: 'officeDelivery',
};

export default pickUpTypes;
